import { Injectable, effect, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CookieConsentService } from './cookie-consent.service';

@Injectable({ providedIn: 'root' })
export class ClarityService {
  private document = inject(DOCUMENT);
  private consentService = inject(CookieConsentService);

  private clarityId = '';
  private enabled = false;
  private initialized = false;

  /**
   * Inicializa o serviço com o ID do projeto Clarity e o flag de ambiente.
   * Deve ser chamado no construtor do AppComponent de cada app.
   *
   * @param clarityId - ID do projeto no painel do Microsoft Clarity
   * @param enabled - Se false, o script nunca é injetado (ambiente dev, por exemplo)
   */
  init(clarityId: string, enabled: boolean): void {
    this.clarityId = clarityId;
    this.enabled = enabled;

    if (!enabled || !clarityId) return;

    // Verifica o consentimento atual e observa mudanças futuras
    effect(() => {
      const status = this.consentService.$status();
      if (status === 'accepted' && !this.initialized) {
        this._injectScript();
      }
    });
  }

  private _injectScript(): void {
    this.initialized = true;

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${this.clarityId}");
    `;
    this.document.head.appendChild(script);
  }
}
